import { trackAwsRumError, trackAwsRumEvent } from './awsTracking';

export function logError(context: string, error: unknown): void {
  try {
    if (error instanceof Error) {
      trackAwsRumError(error);
    }
    trackAwsRumEvent('proprio.error', { context: context, error: String(error) });
  } catch (e) {
    console.error('Error logging error to AWS RUM:', e);
  } finally {
    console.error(context);
  }
};

export function logEvent(eventData: object): void {
  try {
    trackAwsRumEvent('proprio.event', eventData);
    console.log('Event logged:', eventData);
  } catch (error) {
    console.error('Error logging event to AWS RUM:', error);
  }
};

export function logPageView(path: string): void {
  try {
    trackAwsRumEvent('proprio.page_view', { path: path });
    console.log('Page view logged:', path);
  } catch (error) {
    console.error('Error logging page view to tracking services:', error);
  }
}

export function logTrace(category: string, action: string, label: string): void {
  try {
    const traceData = { category, action, label };
    trackAwsRumEvent('proprio.trace', traceData);
    console.log('Trace logged:', traceData);
  } catch (error) {
    console.error('Error logging trace to tracking services:', error);
  }
}

export function onLogin(userId: string): void {
  logTrace('UserProfile', 'proprio_login', userId);
};

export function onLogout(): void {
  logTrace('UserProfile', 'proprio_logout', '');
};
